import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
        fontSize: 15,
        gap: 16,
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start'
        }
    },
    chipRoot: {
        height: 'fit-content',
        cursor: 'pointer'
    },
    chipLabel: {
        padding: 0
    },
    chip: {
        borderRadius: '50px',
        padding: '0 16px',
        fontFamily: 'GreedStandard-Medium',
        fontSize: 15,
        lineHeight: '24px',
        '&:hover': {
            color: 'white !important',
            backgroundColor: 'var(--background-purple) !important'
        }
    }
}))
